import React, { useContext } from 'react';
import { useTheme } from '@emotion/react';
import { AgendaContext } from '../../../contexts/AgendaContext.jsx';
// Mui components
import { Box, Typography } from '@mui/material';
// Hooks
import { toCamelCaseAllWords } from '../../../utils/Hooks/textFormatted.js';
import { useParams } from 'react-router-dom';

function DetailUserConsultorio
  () {

  const { consultorioId } = useParams();

  const consultorioIdSplit = consultorioId.split("-");

  const theme = useTheme();

  const { prestadorSesion } = useContext(AgendaContext);

  const prestadorEncontrado = prestadorSesion.find(prestador => prestador.consultorios.some(consultorio => consultorio.consultorioOsde.some(osde => osde.consultorioId === consultorioId)));

  return (
    prestadorSesion && (
      <Box
        sx={{
          backgroundColor: theme.palette.backgroundPrimary.main,
          height: '118px',
          width: '100%',
          padding: '1.5rem',
          borderRadius: '1rem',
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}>
        <Typography variant="h4">{toCamelCaseAllWords(prestadorEncontrado?.nombre)}</Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '2.5rem'
          }}>
          <Typography variant="bodyM">
            Número de CUIT:{' '}
            <Typography
              component="span"
              style={{ fontFamily: 'NunitoSansBold', whiteSpace: 'nowrap' }}>
              {prestadorEncontrado?.identificador}
            </Typography>
          </Typography>
          <Typography variant="bodyM">
            N° de prestador:{' '}
            <Typography
              component="span"
              style={{ fontFamily: 'NunitoSansBold', whiteSpace: 'nowrap' }}>
              {consultorioIdSplit[1]}
            </Typography>
          </Typography>
        </Box>
      </Box>
    )
  );
}

export default DetailUserConsultorio
  ;
